import * as React from 'react';
import type { SVGProps } from 'react';

const SuccessFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={24}
    height={24}
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333m-1.333 10L3.333 8l.94-.94 2.394 2.387 5.06-5.06.94.946z"
    />
  </svg>
);
export { SuccessFillIcon as ReactComponent };
